import type { IconDefinition } from '../index.tsx';

export const iconVolumeOff: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconVolumeOff',
  icon: [
    16,
    16,
    [],
    '',
    'M16 16H13L8 9.84615V15H6L2 11H0V5H2L3.13793 3.86207L0 0H3L16 16Z M16 8C16 9.1699 15.6651 10.2611 15.0866 11.1835L13.7124 9.49224C13.898 9.03097 14 8.52729 14 8C14 5.79086 12.2091 4 10 4V2C13.3137 2 16 4.68629 16 8Z',
  ],
};
